import Swiper from 'swiper';
import {
    Navigation,
    Autoplay
} from 'swiper/modules';

// slider on landingPage
const homeCarousel = document.querySelector('.blog__carousel');
if (!!homeCarousel) {
    window.addEventListener('DOMContentLoaded', () => {
        const swiper = new Swiper(homeCarousel, {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            // autoplay: {
            //     delay: 5000,
            // },
            navigation: {
                nextEl: '.blog__carousel-next',
                prevEl: '.blog__carousel-prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                }
            }
        });
    });
}
